import React from "react";
import Head from "next/head";

const RefundPolicy = () => {
  return (
    <div className="w-full md:mt-10 mt-8">
      <div className="max-w-screen-xl mx-auto md:px-8 px-4 break-words overflow-hidden">
        <Head>
          <meta charSet="utf-8" />
          <title>Refund Policy | BoloSign</title>
          <meta
            name="description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta name="geo.region" content="IN" />
          <meta name="geo.position" content="22.351115;78.667743" />
          <meta name="ICBM" content="22.351115, 78.667743" />
          <meta name="author" content="BoloSign" />
          <meta name="publisher" content="BoloSign" />
          <meta
            name="robots"
            content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
          />
          <link
            rel="canonical"
            href="https://www.bolosign.com/refund-policy/"
          />

          <meta
            property="og:url"
            content="https://www.bolosign.com/refund-policy/"
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="refund-policy | BoloSign" />
          <meta
            property="og:description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            property="og:image"
            content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:domain" content="https://bolosign.com" />
          <meta
            property="twitter:url"
            content="https://www.bolosign.com/refund-policy/"
          />
          <meta
            name="twitter:title"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            name="twitter:description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            name="twitter:image"
            content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
          />
        </Head>
        <h4 className="text-4xl font-semibold mb-4 capitalize">
          Refund Policy
        </h4>
        <p>
          <p>
            This Refund Policy (Policy) sets forth the terms and conditions
            under which refunds may be granted to users of our services. By
            using our services, you agree to the terms of this Policy. Refund
            requests will be handled on a case-by-case basis at our sole
            discretion, and we reserve the right to deny any refund request that
            does not meet the criteria set forth below.
          </p>

          <h2>1. Eligibility for Refunds</h2>
          <p>
            Refunds may only be considered under exceptional circumstances, such
            as:
          </p>
          <ul>
            <li>
              Technical issues with the service that prevent the User from
              utilizing the product as advertised.
            </li>
            <li>
              Billing errors, such as duplicate charges or incorrect amounts
              charged to the Users account.
            </li>
            <li>
              Other circumstances as determined by us on a case-by-case basis.
            </li>
            <li>
              A fee of $0.30 plus 2% of the original amount will be deducted
              from the refund if the refund request is accepted and processed.
            </li>
          </ul>

          <h2>2. Refund Requests</h2>
          <p>
            To request a refund, the User must contact our support team at{" "}
            <strong>support@boloforms.com</strong>. The refund request must be
            submitted within <strong>7 days</strong> of the original purchase
            date. Any requests submitted after this period will not be
            entertained. The refund request must include the following:
          </p>
          <ul>
            <li>
              The Users registered email address (i.e., the login email
              associated with their account).
            </li>
            <li>A copy of the payment receipt or proof of purchase.</li>
            <li>
              A detailed explanation of the reason for the refund request.
            </li>
          </ul>
          <p>
            Failure to provide sufficient information may delay or result in the
            denial of the refund request.
          </p>

          <h2>3. Processing Time</h2>
          <p>
            Upon receipt of a refund request, we will review the claim and may
            request additional information to assess the validity of the
            request. Refund requests may take up to{" "}
            <strong>30 business days</strong> to process. Once the refund is
            approved, the User will be notified via email, and the refunded
            amount will be credited back to the original payment method used
            during the transaction.
          </p>

          <h2>4. Refund Conditions</h2>
          <p>Refunds will be granted only if:</p>
          <ul>
            <li>
              The refund request is made within <strong>7 days</strong> of the
              original purchase date.
            </li>
            <li>
              The service has not been used in a manner inconsistent with our
              Terms of Service.
            </li>
            <li>
              The request does not violate any applicable laws or regulations.
            </li>
          </ul>
          <p>
            Refunds will not be granted for general dissatisfaction, change of
            mind, or failure to cancel subscriptions before renewal.
          </p>

          <h2>5. Non-Refundable Services</h2>
          <p>
            Certain services or products, such as one-time purchases, setup
            fees, and custom integrations, are <strong>non-refundable</strong>{" "}
            unless otherwise specified in a separate written agreement.
          </p>

          <h2>6. Policy Modifications</h2>
          <p>
            We reserve the right to modify this Refund Policy at any time
            without prior notice. Continued use of our services following any
            such modification constitutes acceptance of the revised Policy.
          </p>

          <p>
            By using our services, you agree to comply with the terms outlined
            in this Policy.
          </p>
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
